import { createStore } from "vuex";
import Jwt from "@/common/jwt";
import Locale from "@/common/locale";
import Route from "@/common/route";
import services from "@/services";

export default createStore({
  state: {
    token: {
      accessToken: Jwt.getAccessToken(),
      refreshToken: Jwt.getRefreshToken(),
    },
    isAuthenticated: !!Jwt.getAccessToken(),
    saveLoginInfo: Jwt.getLoginInfo(),
    locale: Locale.getLocale(),
    userId: Jwt.getUserId(),
    relicId: Route.getRelicId(),
    nextRoute: Route.getNextRoute(),
    isVideo: null,
  },
  getters: {
    getAccessToken: function (state) {
      return state.token.accessToken;
    },
    getRefreshToken: function (state) {
      return state.token.refreshToken;
    },
    isAuthenticated: function (state) {
      return state.isAuthenticated;
    },
    getLoginInfo: function (state) {
      return state.saveLoginInfo;
    },
    getLocale: function (state) {
      return JSON.parse(state.locale);
    },
    getUserId: function (state) {
      return state.userId;
    },
    getRelicId: function (state) {
      return state.relicId;
    },
    getNextRoute: function (state) {
      return state.nextRoute;
    },
    getIsVideo: function (state) {
      return state.isVideo;
    },
  },
  mutations: {
    login: function (state, payload) {
      state.token.accessToken = payload.accessToken;
      state.isAuthenticated = true;
      Jwt.saveAccessToken(payload.accessToken);
      Jwt.saveRefreshToken(payload.refreshToken);
    },
    saveLoginInfo: function (state, payload) {
      state.saveLoginInfo = payload;
      if (payload) {
        Jwt.saveLoginInfo(JSON.stringify(payload));
      } else {
        Jwt.removeLoginInfo();
      }
    },
    saveLocale: function (state, payload) {
      if (payload) {
        state.locale = JSON.stringify(payload);
        Locale.saveLocale(JSON.stringify(payload));
      }
    },
    saveUserId: function (state, payload) {
      state.userId = payload;
      if (payload) {
        Jwt.saveUserId(payload);
      }
    },
    saveRelicId: function (state, payload) {
      state.relicId = payload;
      if (payload) {
        Route.saveRelicId(payload);
      }
    },
    saveNextRoute: function (state, payload) {
      state.nextRoute = payload;
      if (payload) {
        Route.saveNextRoute(payload);
      }
    },
    saveIsVideo: function (state, payload) {
      state.isVideo = payload;
    },
  },
  actions: {
    login: function (context, payload) {
      const params = {};

      params.loginid = payload.loginid;
      params.password = payload.password;

      return new Promise((resolve, reject) => {
        console.log(resolve);
        console.log(reject);

        services.login(params).then(
          (response) => {
            const { data } = response;
            if (response.status == 200) {
              context.commit("login", {
                accessToken: data.token,
                refreshToken: data.refreshToken,
              });
              services.findMyInfoByToken().then(
                (response) => {
                  const { data } = response;
                  context.commit("saveUserId", data.id);
                  console.log(data.id);
                },
                (error) => {
                  const { data } = error.response;
                  reject(data.message);
                }
              );
              if (payload.saveInfo) {
                context.commit("saveLoginInfo", {
                  loginInfo: payload,
                });
              } else {
                Jwt.removeLoginInfo();
              }
            }
            resolve(response);
          },
          (error) => {
            // status 404
            console.log(error);
            const { data } = error.response;
            reject(data);
          }
        );
      });
    },
  },
});
